export enum SocialLinksType {
  Facebook = 'FACEBOOK',
  LinkedIn = 'LINKEDIN',
  Medium = 'MEDIUM',
  Twitter = 'TWITTER',
  GitHub = 'GITHUB',
  StackOverflow = 'STACKOVERFLOW',
  Other = 'OTHER',
}
